import { ChangeEvent, FC, memo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ChipSelectorControlled } from 'components/_basic/Form/ChipSelector/ChipSelectorControlled';
import { RadioControlled } from 'components/_basic/Form/Radio';
import { Responsive } from 'components/_basic/Responsive';
import { LIFE_CYCLE_STAGES_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/options_deu';
import { LIFE_CYCLE_STAGES_OPTIONS } from 'components/BusinessToolForm/constants/options';
import { LIFE_CYCLE_STAGES_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/options_ua';
import {
  COMPANY_OVERVIEW_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/Overview/CompanyOverview/utils/form';

import { concatWithDot } from 'helpers/string';

import { ISharedProps } from '../utils/types';

import styles from './LifeCycleStages.module.scss';

export const LifeCycleStages: FC<ISharedProps> = memo(({ canAccess }) => {
  const { control } = useFormContext();
  const { i18n } = useTranslation();
  const name = concatWithDot(prefix, COMPANY_OVERVIEW_NAMES.LIFE_CYCLE_STAGES);
  const id = 'overview.company.lifeCycleStages';
  const { field } = useController({
    name,
    control,
  });

  const getOptionsToChoose = (lang: string) => {
    switch (lang) {
      case 'de':
        return LIFE_CYCLE_STAGES_OPTIONS_DEU;

      case 'uk':
        return LIFE_CYCLE_STAGES_OPTIONS_UA;

      default:
        return LIFE_CYCLE_STAGES_OPTIONS;
    }
  };
  const onChange = (_: ChangeEvent<HTMLInputElement>, value: string) => {
    const valueAsObject = getOptionsToChoose(i18n.language).find(
      (option) => option.value.toLowerCase() === value.toLowerCase(),
    );
    if (valueAsObject) {
      field.onChange([valueAsObject]);
    }
  };

  return (
    <>
      <Responsive mobile>
        <RadioControlled
          name={name}
          id={id}
          disabled={canAccess}
          options={getOptionsToChoose(i18n.language)}
          radioControlledStyles={{ radioLabel: styles.radioLabel }}
          onChange={onChange}
        />
      </Responsive>
      <Responsive aboveMobile>
        <ChipSelectorControlled
          control={control}
          disabled={canAccess}
          id={id}
          options={getOptionsToChoose(i18n.language)}
          name={name}
          chipStyles={{ chipStyle: styles.chip }}
        />
      </Responsive>
    </>
  );
});
